import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../../shared/validators/customvalidators';
import { AccountService } from './../../../shared/services/auth';
import { SubSink } from 'subsink';

@Component({
  templateUrl: './reset-pwd-req.component.html',
  standalone: false
})
export class ResetPasswordRequestComponent implements OnInit, OnDestroy {

  @ViewChild('newPassword')
  newPasswordInput;

  showTypingText = 'show typing';

  form: UntypedFormGroup;

  isSubmitting = false;

  feedbackMessages: any[] = [];
  successMessage = '';

  userEmail: string;
  resetPasswordToken: string;
  operationToken: string;
  parametersAreValid: boolean;

  emailSent = false;

  private subs = new SubSink();
  private queryStringParams: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private _accountService: AccountService) {
  }

  ngOnInit() {
    this.queryStringParams = this.route
      .queryParams
      .subscribe(params => {
        this.userEmail = params['email'];
      });

    this.initForms();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.queryStringParams.unsubscribe();
  }

  onSubmitResetPasswordRequest() {
    this.isSubmitting = true;
    this.subs.sink = this.validateEmail()
      .subscribe(
        () => {
          this.emailSent = true;
        },
        () => {
          this.emailSent = true;
        }
      );
  }

  validateEmail() {
    const payload = {
      email: this.form.value.email
    };

    return this._accountService.requestResetPassword(payload);
  }

  private initForms() {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl(null, [Validators.required, CustomValidators.emailValidator])
    });

    if (this.userEmail) {
      this.form.get('email').setValue(this.userEmail);
    }
  }

  initResetPassword() {
    this.successMessage = '';
    this.feedbackMessages = [];

    const payload = {
      email: this.userEmail,
      resetPasswordToken: this.resetPasswordToken,
      operationToken: this.operationToken
    };

    return this._accountService.initResetPassword(payload);
  }

  private goToMain() {
    this.router.navigate(['useraccount/user/properties']);
  }

  private handleError(errors) {
    // this.isResetingPassword = false;
    // this.isCheckingParameters = false;
    this.feedbackMessages = errors;
    // this.goToMain();
  }
}
